import { React, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom'; 
import Swal from "sweetalert2";

const ExceptionRoute = () => {
    const navigate = useNavigate();
    Swal.fire({
        title: '<p style="color:red">화면 없음</p>',
        text: '존재하지 않는 화면이므로 이전 페이지로 이동합니다.',
        confirmButtonText: '확인'
    }).then((result) => {
        navigate(-1)
    });
}

export default ExceptionRoute;
